/*
 * KAIROSDECOR · Comedor elevado — lógica de la landing.
 *  - Historia controlada por scroll (3D en vivo, secuencia de imágenes o respaldo estático)
 *  - Estado compartido de la variante (tamaño) entre secciones
 *  - Compra: abre el formulario contraentrega de Releasit; si no está, usa carrito/checkout
 *  - Barra de compra fija inferior
 * Sin dependencias. Se protege contra cargas dobles (varias secciones lo incluyen).
 */
(function () {
  'use strict';
  if (window.KC && window.KC.__loaded) return;

  var doc = document;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var clamp = function (v, a, b) { return Math.min(b === undefined ? 1 : b, Math.max(a || 0, v)); };
  var norm = function (s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  };
  var $ = function (sel, root) { return (root || doc).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); };
  var readJSON = function (el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } };

  /* ---------------------------------------------------------------------- */
  /* Estado del producto / variante                                          */
  /* ---------------------------------------------------------------------- */
  var KC = window.KC = window.KC || {};
  KC.__loaded = true;
  // Configuración editable en: Configuración del tema > KAIROSDECOR - Comedor
  var CFG = Object.assign({ revealStyle: 'fade', revealMobile: 'fade', speed: 100, snap: false, quality: 'auto' }, window.KC_CFG || {});
  var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  var isPhone = function () { return window.innerWidth < 750; };
  KC.headerH = 0;
  var listeners = [];
  KC.product = null;
  KC.variant = null;

  function loadProduct() {
    if (KC.product) return KC.product;
    var el = $('script[data-kc-product]');
    if (!el) return null;
    KC.product = readJSON(el);
    if (KC.product && KC.product.variants) {
      var current = KC.product.variants.filter(function (v) { return v.id === KC.product.selected; })[0];
      KC.variant = current || KC.product.variants[0];
    }
    return KC.product;
  }

  KC.onChange = function (fn) { listeners.push(fn); if (KC.variant) fn(KC.variant, 'init'); };

  KC.setVariant = function (id, source) {
    var p = loadProduct(); if (!p) return;
    var v = p.variants.filter(function (x) { return String(x.id) === String(id); })[0];
    if (!v || (KC.variant && KC.variant.id === v.id && source !== 'force')) return;
    KC.variant = v;
    listeners.forEach(function (fn) { try { fn(v, source); } catch (e) { console.error(e); } });
    // URL compartible ?variant=
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (e) {}
  };

  // Busca la variante cuyo valor de opción coincide con el texto (ej. "Mediano")
  KC.variantForOption = function (value) {
    var p = loadProduct(); if (!p) return null;
    var n = norm(value); if (!n) return null;
    var exact = p.variants.filter(function (v) { return v.options.some(function (o) { return norm(o) === n; }); });
    if (exact.length) return exact.filter(function (v) { return v.available; })[0] || exact[0];
    var partial = p.variants.filter(function (v) { return norm(v.title).indexOf(n) !== -1; });
    return partial[0] || null;
  };

  KC.sizeLabel = function (v) {
    if (!v || v.title === 'Default Title' || (v.options && v.options[0] === 'Default Title')) return '';
    var p = loadProduct();
    if (p && p.sizeIndex > -1 && v.options[p.sizeIndex]) return v.options[p.sizeIndex];
    return v.title;
  };

  /* ---------------------------------------------------------------------- */
  /* Compra: Releasit (contraentrega) → respaldo carrito / checkout          */
  /* ---------------------------------------------------------------------- */
  var RSI_SELECTORS = [
    '._rsi-buy-now-button', '[class*="_rsi-buy-now-button"]', '[class*="_rsi-cod-form-button"]',
    '[class*="_rsi-button"]', 'button[class*="rsi-cod"]', 'a[class*="rsi-cod"]'
  ];

  function releasitPresent() {
    return !!(window._RSI_COD_FORM || window.RSI || window.releasit ||
      $('[class*="_rsi"], [id*="_rsi"], script[src*="releasit"], script[src*="releas.it"], link[href*="releasit"]'));
  }

  function findRsiButton(buy) {
    var extra = buy && buy.getAttribute('data-rsi-selector');
    var sels = (extra ? [extra] : []).concat(RSI_SELECTORS);
    var scopes = [buy && $('.kc-rsi-slot', buy), buy, doc].filter(Boolean);
    for (var s = 0; s < scopes.length; s++) {
      for (var i = 0; i < sels.length; i++) {
        var el;
        try { el = $(sels[i], scopes[s]); } catch (e) { el = null; }
        if (el && !el.closest('[data-kc-own-cta]') && !el.closest('.kc-sticky')) return el;
      }
    }
    return null;
  }

  function syncForms(v) {
    $$('form[data-kc-form]').forEach(function (f) {
      var input = f.querySelector('input[name="id"]');
      if (input && String(input.value) !== String(v.id)) {
        input.value = v.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    // Algunos formularios de apps leen el selector nativo de variantes
    var sel = $('form[data-kc-form] select[name="id"]');
    if (sel) { sel.value = v.id; sel.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  function addToCart(v, goCheckout) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (goCheckout) { window.location.href = root + 'cart/' + v.id + ':1'; return Promise.resolve(); }
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      window.location.href = root + 'cart';
    });
  }

  KC.purchase = function (trigger) {
    loadProduct();
    var v = KC.variant; if (!v) return;
    if (!v.available) { var b = $('[data-kc-buy-section]'); if (b) b.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    var buy = $('[data-kc-buy-section]');
    var mode = (buy && buy.getAttribute('data-mode')) || 'releasit';
    syncForms(v);
    if (mode === 'releasit') {
      var btn = findRsiButton(buy);
      if (btn) { btn.click(); return; }
      var hook = buy && $('[data-kc-rsi-hook]', buy);
      if (hook && releasitPresent()) { hook.click(); return; }
      if (designMode) { console.warn('[KAIROSDECOR] Releasit no está activo en el editor; en la tienda publicada se abrirá su formulario.'); }
      // Releasit no disponible: respaldo según ajuste
      mode = (buy && buy.getAttribute('data-fallback')) || 'checkout';
    }
    if (trigger) trigger.classList.add('is-loading');
    addToCart(v, mode === 'checkout').catch(function () {
      var f = $('form[data-kc-form]'); if (f) f.submit();
    }).then(function () { if (trigger) trigger.classList.remove('is-loading'); });
  };

  doc.addEventListener('click', function (e) {
    var t = e.target.closest('[data-kc-buy]');
    if (t) { e.preventDefault(); KC.purchase(t); return; }
    var go = e.target.closest('[data-kc-goto]');
    if (go) {
      var target = $(go.getAttribute('data-kc-goto'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); }
    }
  });

  /* ---------------------------------------------------------------------- */
  /* Medición del header fijo de Horizon                                      */
  /* ---------------------------------------------------------------------- */
  function headerOffset() {
    var h = $('#header-component') || $('header-component') || $('.header-section') || $('#header-group');
    if (!h) return 0;
    var cs = window.getComputedStyle(h.closest('[id^="shopify-section"]') || h);
    var sticky = cs.position === 'sticky' || cs.position === 'fixed' || window.getComputedStyle(h).position === 'sticky';
    return sticky ? Math.round(h.getBoundingClientRect().height) : 0;
  }
  function applyHeader() {
    var hh = headerOffset(); KC.headerH = hh;
    $$('.kc').forEach(function (el) { el.style.setProperty('--kc-header', hh + 'px'); });
  }

  /* ---------------------------------------------------------------------- */
  /* Historia con scroll                                                      */
  /* ---------------------------------------------------------------------- */
  var stories = [];

  function initStory(root) {
    var cfg = readJSON($('script[data-kc-config]', root)) || {};
    var track = $('.kc-story__track', root);
    var stage = $('.kc-story__stage', root);
    var chapters = $$('[data-kc-chapter]', root);
    var layers = $$('[data-kc-layer]', root);
    var dots = $$('.kc-story__progress span', root);
    var canvas = $('.kc-story__canvas', root);
    var hero = $('.kc-story__hero', root);

    // Línea de tiempo: portada + capítulos con su peso relativo
    // cada paso ocupa el mismo recorrido: un deslizamiento = un paso (la duración de la animación es por tiempo)
    var items = [{ type: 'intro', w: 1, el: null }].concat(chapters.map(function (c) {
      return { type: c.getAttribute('data-scene') || 'outro', w: 1, el: c };
    }));
    var total = items.reduce(function (s, it) { return s + it.w; }, 0);
    var acc = 0;
    items.forEach(function (it) { it.a = acc / total; acc += it.w; it.b = acc / total; });
    var timeline = items.map(function (it) { return { type: it.type, a: it.a, b: it.b }; });
    var perVh = cfg.vhPerStep || 90;
    track.style.setProperty('--kc-len', Math.round(total * perVh + 100) + 'vh');
    if (chapters.length) chapters[chapters.length - 1].classList.add('is-last');

    var st = { root: root, cfg: cfg, items: items, timeline: timeline, p: -1, scene: null, seq: null, visible: false };
    stories.push(st);

    var isStatic = reduceMotion || cfg.mode === 'static';
    if (isStatic) root.classList.add('is-static');

    // ---------- motor visual ----------
    function startEngine() {
      if (st.started) return; st.started = true;
      if (cfg.mode === 'sequence' && cfg.seq && cfg.seq.first && cfg.seq.count > 1) {
        st.seq = createSequence($('.kc-story__seq', root) || canvas, cfg.seq);
        root.classList.add('is-ready');
        update(true);
        return;
      }
      if (cfg.mode === 'images') { root.classList.add('is-fallback'); return; }
      if (!webglOK()) { root.classList.add('is-fallback'); if (!cfg.poster) root.classList.add('is-static'); return; }
      loadScript(cfg.scriptUrl).then(function () {
        if (!window.KairosComedor3D) throw new Error('3D');
        st.scene = window.KairosComedor3D.create(canvas, {
          dims: cfg.dims, timeline: timeline, bodyColor: cfg.productColor, waterColor: cfg.waterColor,
          reducedMotion: isStatic, lite: CFG.quality === 'lite' || (CFG.quality === 'auto' && (coarse || !!(navigator.deviceMemory && navigator.deviceMemory < 4))), maxDpr: CFG.quality === 'high' ? 2 : (coarse ? 1.5 : 2)
        });
        root.classList.add('is-ready');
        if (isStatic) st.scene.setProgress(1); else { st.band = null; bandStep(); st.scene.setProgress(st.disp || 0); update(true); play(); }
      }).catch(function (e) {
        console.warn('[KAIROSDECOR] 3D no disponible, se usa la imagen de respaldo.', e);
        root.classList.add('is-fallback');
      });
    }
    st.start = startEngine;

    // ---------- progreso por pasos ----------
    // Cada deslizada lleva a un paso; la animación de ese paso se reproduce completa sola
    // (armado, tazones, agua y comida), sin que la persona tenga que seguir moviendo el dedo.
    var SPD = Math.max(0.5, Math.min(2, (parseFloat(CFG.speed) || 100) / 100));
    var DUR = { intro: 600 / SPD, legs: 2200 / SPD, bowls: 2000 / SPD, fill: 3200 / SPD, dog: 900 / SPD, outro: 800 / SPD };
    var nextHint = $('.kc-next', root), nextStep = $('[data-kc-next-step]', root);
    var animIdx = []; items.forEach(function (it, i) { if (it.type === 'legs' || it.type === 'bowls' || it.type === 'fill') animIdx.push(i); });
    st.disp = 0; st.target = 0; st.idx = 0; st.playing = false;
    var raf = 0, lastT = 0;
    function stepTarget(idx) { return idx === 0 ? 0 : (idx === items.length - 1 ? 1 : items[idx].b); }
    function itemAt(pp) { for (var i = 0; i < items.length; i++) { if (pp < items[i].b - 1e-6) return i; } return items.length - 1; }
    // franja libre para el producto en celular: entre el header/portada y la tarjeta de texto
    st.band = null;
    function bandTarget() {
      if (window.innerWidth >= 750) return null;
      var sr = stage.getBoundingClientRect(), H = stage.clientHeight || 1;
      var fr = function (y) { return (y - sr.top) / H; };
      var t = 0.02, b = 0.9, it = items[st.idx];
      if (st.idx === 0) {
        var lead = $('.kc-story__hero .kc-lead', root) || $('.kc-story__hero .kc-h1', root), hint = $('.kc-hint', root);
        if (lead) t = fr(lead.getBoundingClientRect().bottom) + 0.02;
        if (hint) b = fr(hint.getBoundingClientRect().top) - 0.02;
      } else if (it && it.el) {
        var er = it.el.getBoundingClientRect();
        if (it.el.classList.contains('kc-chapter--top')) {
          t = fr(er.bottom) + 0.02;
          b = nextHint ? fr(nextHint.getBoundingClientRect().top) - 0.02 : 0.88;
        } else {
          b = fr(er.top) - 0.02;
        }
      }
      if (b - t < 0.24) { var c = (t + b) / 2; t = c - 0.12; b = c + 0.12; }
      return { t: t, b: b };
    }
    st.bandTgt = null; st.bandIdx = -1;
    function bandStep() { // se mueve suavemente hacia la franja nueva; devuelve true si aún se mueve
      if (st.bandIdx !== st.idx || st.bandDirty) { st.bandTgt = bandTarget(); st.bandIdx = st.idx; st.bandDirty = false; }
      var tg = st.bandTgt;
      if (!tg) { if (st.band) { st.band = null; if (st.scene && st.scene.setBand) st.scene.setBand(null); } return false; }
      if (!st.band) st.band = { t: tg.t, b: tg.b };
      var dt = tg.t - st.band.t, db = tg.b - st.band.b, moving = Math.abs(dt) > 0.002 || Math.abs(db) > 0.002;
      st.band.t += moving ? dt * 0.14 : dt; st.band.b += moving ? db * 0.14 : db;
      if (st.scene && st.scene.setBand) st.scene.setBand(st.band.t, st.band.b);
      return moving;
    }
    function paint() {
      var d = st.disp;
      items.forEach(function (it) { if (it.el) it.el.style.setProperty('--cp', clamp((d - it.a) / (it.b - it.a)).toFixed(3)); });
      if (st.scene) st.scene.setProgress(d);
      if (st.seq) st.seq.draw(d);
      // indicación "sigue deslizando": solo cuando terminó la animación del paso y aún quedan pasos
      if (nextHint) {
        var show = !st.playing && st.idx > 0 && st.idx < items.length - 1 && !root.classList.contains('is-end');
        nextHint.classList.toggle('is-show', show);
        if (nextStep) {
          var done = animIdx.filter(function (i) { return i <= st.idx; }).length;
          nextStep.textContent = done < animIdx.length ? ('Paso ' + (done + 1) + ' de ' + animIdx.length) : '';
        }
      }
    }
    function tick(now) {
      raf = 0;
      var dt = lastT ? Math.min(100, now - lastT) : 16; lastT = now;
      var t = st.target, d = st.disp;
      if (!st.onScreen) { st.disp = t; st.playing = false; lastT = 0; paint(); return; }
      var bandMoving = bandStep();
      if (Math.abs(t - d) < 1e-5) {
        st.disp = t; st.playing = false; paint();
        if (bandMoving) { raf = requestAnimationFrame(tick); } else { lastT = 0; }
        return;
      }
      var it = items[itemAt(t > d ? d + 1e-6 : d - 1e-6)];
      var rate = (it.b - it.a) / (DUR[it.type] || 1500) * (t < d ? 3 : 1);
      st.disp = t > d ? Math.min(t, d + rate * dt) : Math.max(t, d - rate * dt);
      st.playing = true; paint();
      raf = requestAnimationFrame(tick);
    }
    function play() { if (!raf) { lastT = 0; raf = requestAnimationFrame(tick); } }
    st.play = play;

    function update(force) {
      if (isStatic) return;
      var r = track.getBoundingClientRect();
      var vh = stage.clientHeight || window.innerHeight;
      var range = Math.max(1, r.height - vh);
      var p = clamp(-r.top / range);
      var onNow = r.bottom > 0 && r.top < (window.innerHeight || vh);
      if (onNow !== st.onScreen) { st.onScreen = onNow; force = true; }
      if (!force && Math.abs(p - st.p) < 0.0005) return;
      st.p = p;
      var gap = Math.max(0, Math.round(r.top - KC.headerH));
      if (gap !== st.gap) { st.gap = gap; root.style.setProperty('--kc-top-gap', gap + 'px'); }
      if (!isPhone()) root.style.setProperty('--kc-draw', clamp(0.3 + p * 1.6).toFixed(3));
      var intro = items[0];
      root.style.setProperty('--kc-hero-out', clamp((p - intro.b * 0.08) / (intro.b * 0.5)).toFixed(3));

      var idx = p >= 0.995 ? items.length - 1 : itemAt(p);
      st.idx = idx;
      // animación de la mano solo cuando la indicación está en pantalla (fuera de ella se pausa)
      var hintOn = st.onScreen && idx === 0;
      if (hintOn !== st.hintOn) { st.hintOn = hintOn; root.classList.toggle('kc-hint-on', hintOn); }
      items.forEach(function (it, i) { if (it.el) it.el.classList.toggle('is-on', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx - 1); });
      layers.forEach(function (l) {
        var on = parseInt(l.getAttribute('data-kc-layer'), 10) + 1 === idx;
        if (on !== l.classList.contains('is-on')) {
          l.classList.toggle('is-on', on);
          var vid = $('video', l);
          if (vid) { if (on) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); } else vid.pause(); }
        }
      });
      root.classList.toggle('is-end', p > 0.985);
      var tgt = stepTarget(idx);
      if (tgt !== st.target) {
        // si la persona se adelantó más de un paso, no se reproducen los pasos intermedios:
        // se salta al inicio del paso actual y solo se anima ese (la página nunca se queda atrás)
        var from = itemAt(st.disp + 1e-6);
        if (Math.abs(from - idx) > 1) st.disp = tgt > st.disp ? items[idx].a : tgt;
        st.target = tgt;
      }
      // precarga del video del capítulo siguiente para que esté listo al llegar
      layers.forEach(function (l) {
        var li = parseInt(l.getAttribute('data-kc-layer'), 10) + 1, vid = $('video', l);
        if (vid && li <= idx + 1 && !vid.__kcLoaded) { vid.__kcLoaded = 1; vid.preload = 'auto'; try { vid.load(); } catch (e) {} }
      });
      play();
      paint();
      KC.storyProgress = p;
      KC.storyStarted = idx >= 1;
      KC.storyDone = r.bottom < vh * 0.55;
      updateSticky();
    }

    // puntos de anclaje: un deslizamiento normal lleva al siguiente paso (solo pantallas táctiles)
    function placeSnaps() {
      $$('.kc-snap', track).forEach(function (n) { n.remove(); });
      doc.documentElement.classList.remove('kc-snap-on');
      if (!CFG.snap || isStatic || !coarse || window.innerWidth >= 990) return;
      var range = track.offsetHeight - (stage.clientHeight || window.innerHeight);
      var hh = KC.headerH || 0;
      items.forEach(function (it, i) {
        var m = doc.createElement('div'); m.className = 'kc-snap';
        m.style.top = Math.round((i === 0 ? 0 : it.a * range + 6) + (i === 0 ? 0 : hh)) + 'px';
        track.appendChild(m);
      });
      var end = doc.createElement('div'); end.className = 'kc-snap kc-snap--end'; end.style.top = (track.offsetHeight - 2) + 'px'; track.appendChild(end);
      doc.documentElement.classList.add('kc-snap-on');
    }
    st.placeSnaps = placeSnaps;
    setTimeout(placeSnaps, 300);
    st.update = update;

    // arrancar cuando la sección se acerca
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { st.visible = x.isIntersecting; if (x.isIntersecting) startEngine(); });
      }, { rootMargin: '200px 0px' });
      io.observe(root);
    } else startEngine();
    // Primer frame cuanto antes (la portada es lo primero que se ve)
    if (root.getBoundingClientRect().top < window.innerHeight * 1.5) {
      (window.requestIdleCallback || function (f) { return setTimeout(f, 120); })(startEngine, { timeout: 600 });
    }
    if (isStatic) { if (hero) hero.style.removeProperty('opacity'); }
    update(true);
  }

  function webglOK() {
    try {
      var c = doc.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl')));
    } catch (e) { return false; }
  }

  var scriptCache = {};
  function loadScript(src) {
    if (!src) return Promise.reject(new Error('no src'));
    if (scriptCache[src]) return scriptCache[src];
    scriptCache[src] = new Promise(function (res, rej) {
      var s = doc.createElement('script'); s.src = src; s.async = true;
      s.onload = res; s.onerror = rej; doc.head.appendChild(s);
    });
    return scriptCache[src];
  }

  // Secuencia de imágenes (fotogramas renderizados subidos a Archivos de Shopify)
  function createSequence(canvas, seq) {
    var ctx = canvas.getContext('2d');
    var m = String(seq.first).match(/^(.*?)(\d+)(\.[a-z0-9]+)(\?.*)?$/i);
    var frames = new Array(seq.count), loaded = new Array(seq.count);
    var url = function (i) {
      if (!m) return seq.first;
      var n = String(parseInt(m[2], 10) + i);
      while (n.length < m[2].length) n = '0' + n;
      return m[1] + n + m[3] + (m[4] || '');
    };
    var last = -1, pending = -1;
    function load(i) {
      if (frames[i]) return; var im = new Image(); im.decoding = 'async';
      im.onload = function () { loaded[i] = true; if (pending === i || last === -1) paint(i); };
      im.src = url(i); frames[i] = im;
    }
    // orden de carga: primero, luego cada 8, cada 4, cada 2 y el resto
    load(0);
    [8, 4, 2, 1].forEach(function (step, k) {
      setTimeout(function () { for (var i = 0; i < seq.count; i += step) load(i); }, 300 + k * 400);
    });
    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = canvas.clientWidth * dpr; canvas.height = canvas.clientHeight * dpr;
      last = -1;
    }
    function paint(i) {
      var im = frames[i]; if (!im || !loaded[i]) return false;
      var cw = canvas.width, ch = canvas.height, ir = im.naturalWidth / im.naturalHeight, cr = cw / ch;
      var w, h; if (ir > cr) { w = cw; h = cw / ir; } else { h = ch; w = ch * ir; } // contain
      ctx.clearRect(0, 0, cw, ch); ctx.drawImage(im, (cw - w) / 2, (ch - h) / 2, w, h); last = i; return true;
    }
    size(); window.addEventListener('resize', size);
    return {
      draw: function (p) {
        var i = Math.round(p * (seq.count - 1)); pending = i;
        if (i === last) return;
        if (!paint(i)) { // el más cercano ya cargado
          for (var d = 1; d < seq.count; d++) { if (paint(i - d) || paint(i + d)) break; }
          load(i);
        }
      }
    };
  }

  /* ---------------------------------------------------------------------- */
  /* Selector de tamaños (sección comparación)                               */
  /* ---------------------------------------------------------------------- */
  function initSizes(root) {
    var tabs = $$('[role="tab"]', root);
    var panels = $$('[role="tabpanel"]', root);
    var wrap = $('.kc-tabs', root);
    var data = readJSON($('script[data-kc-sizes]', root)) || [];

    function select(i, fromStore) {
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
      if (wrap) wrap.style.setProperty('--i', i);
      drawScale(root, data, i);
      if (!fromStore) {
        var v = KC.variantForOption(tabs[i].getAttribute('data-option'));
        if (v) KC.setVariant(v.id, 'sizes');
      }
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[n].focus(); select(n);
        }
      });
    });
    KC.onChange(function (v) {
      var label = norm(KC.sizeLabel(v));
      var idx = tabs.map(function (t) { return norm(t.getAttribute('data-option')); }).indexOf(label);
      if (idx > -1) select(idx, true);
    });
    if (tabs.length) select(Math.max(0, tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; })), true);
  }

  // Dibujo a escala real (vista lateral del lado largo), con la forma real del producto:
  // falda con esquinas redondeadas y remaches, patas en "U" de 2,8 cm que abren hacia afuera,
  // pie apoyado en el piso y tazones de acero que asoman bajo la falda.
  function drawScale(root, data, cur) {
    var holder = $('[data-kc-scale]', root); if (!holder || !data.length) return;
    var R = Math.PI / 180, PIV = 2, INSET = 2.1, AW = 2.8;
    function geo(d) {
      var ang = (d.angle || 60) * R, pH = d.h - PIV;
      var run = pH / Math.tan(ang), hw = AW / 2;
      var reach = d.l / 2 - INSET + run + hw / Math.sin(ang);
      return { ang: ang, pH: pH, run: run, hw: hw, reach: reach };
    }
    var maxHalf = 0, maxH = 0;
    data.forEach(function (d) { var g = geo(d); maxHalf = Math.max(maxHalf, g.reach, d.l / 2); maxH = Math.max(maxH, d.h); });
    var W = 340, H = 178, padL = 14, padR = 64, base = H - 30;
    var k = Math.min((W - padL - padR) / (2 * maxHalf), (base - 34) / maxH);
    var cx = padL + (W - padL - padR) / 2;
    var cs = getComputedStyle(root);
    var ink = (cs.getPropertyValue('--kc-ink') || '#0b0b0c').trim(), blue = (cs.getPropertyValue('--kc-blue') || '#1e4fd6').trim();
    var f = function (n) { return Math.round(n * 10) / 10; };

    function shape(d, active) {
      var g = geo(d), L = d.l * k, top = base - d.h * k, sk = (d.skirt || 3.5) * k;
      var x0 = cx - L / 2, x1 = cx + L / 2, r = Math.min(0.6 * k, sk / 2);
      var out = '';
      var legFill = active ? ink : 'none', stroke = active ? 'none' : '#c4c8cf', sw = active ? 0 : 1.3;
      // patas (detrás de la falda)
      [1, -1].forEach(function (side) {
        var px = side > 0 ? x1 - INSET * k : x0 + INSET * k, py = top + PIV * k;
        var dx = side * Math.cos(g.ang), dy = Math.sin(g.ang), nx = -side * Math.sin(g.ang) * -1, ny = Math.cos(g.ang);
        var hw = g.hw * k;
        // normal perpendicular a la dirección del brazo
        nx = -dy * side * side; ny = dx * 1; var nl = Math.hypot(nx, ny); nx /= nl; ny /= nl;
        var e = function (sg) { var ox = px + nx * hw * sg, oy = py + ny * hw * sg; var t = (base - oy) / dy; return [ox + dx * t, base]; };
        var p1 = [px + nx * hw, py + ny * hw], p2 = [px - nx * hw, py - ny * hw], f1 = e(1), f2 = e(-1);
        out += '<path d="M' + f(p1[0]) + ' ' + f(p1[1]) + 'L' + f(f1[0]) + ' ' + f(f1[1]) + 'L' + f(f2[0]) + ' ' + f(f2[1]) + 'L' + f(p2[0]) + ' ' + f(p2[1]) + 'Z" fill="' + legFill + '" stroke="' + stroke + '" stroke-width="' + sw + '" stroke-linejoin="round"/>';
      });
      // tazones: cuerpo que cuelga bajo la bandeja (se ve si es más profundo que la falda)
      var bowl = (d.bowl || 14) * k, depth = (parseFloat(String(d.depth || '5').replace(',', '.')) || 5) * k;
      var gap = Math.max(3, (d.l - 2 * (d.bowl || 14)) / 3) * k;
      [-1, 1].forEach(function (sd) {
        var bx = cx + sd * (bowl + gap) / 2, rt = bowl / 2 - 0.1 * k, rb = rt * 0.74;
        var y0 = top, y1 = top + depth;
        out += '<path d="M' + f(bx - rt) + ' ' + f(y0) + 'L' + f(bx - rb) + ' ' + f(y1 - 0.4 * k) + 'Q' + f(bx - rb) + ' ' + f(y1) + ' ' + f(bx - rb + 0.5 * k) + ' ' + f(y1) + 'L' + f(bx + rb - 0.5 * k) + ' ' + f(y1) + 'Q' + f(bx + rb) + ' ' + f(y1) + ' ' + f(bx + rb) + ' ' + f(y1 - 0.4 * k) + 'L' + f(bx + rt) + ' ' + f(y0) + 'Z" fill="' + (active ? 'url(#kc-steel)' : 'none') + '" stroke="' + (active ? '#9aa1aa' : '#d3d6db') + '" stroke-width="' + (active ? .8 : 1.1) + '"/>';
        // borde del tazón apoyado sobre la bandeja
        out += '<rect x="' + f(bx - bowl / 2 - 0.9 * k) + '" y="' + f(top - 0.35 * k) + '" width="' + f(bowl + 1.8 * k) + '" height="' + f(Math.max(1.2, 0.35 * k)) + '" rx="1" fill="' + (active ? '#b9bfc6' : 'none') + '" stroke="' + (active ? 'none' : '#d3d6db') + '"/>';
      });
      // falda lateral con esquinas inferiores redondeadas + remaches del pivote
      out += '<path d="M' + f(x0) + ' ' + f(top) + 'H' + f(x1) + 'V' + f(top + sk - r) + 'Q' + f(x1) + ' ' + f(top + sk) + ' ' + f(x1 - r) + ' ' + f(top + sk) + 'H' + f(x0 + r) + 'Q' + f(x0) + ' ' + f(top + sk) + ' ' + f(x0) + ' ' + f(top + sk - r) + 'Z" fill="' + (active ? ink : '#fff') + '" stroke="' + (active ? 'none' : '#c4c8cf') + '" stroke-width="' + (active ? 0 : 1.3) + '"/>';
      if (active) {
        [x0 + INSET * k, x1 - INSET * k].forEach(function (rx) {
          out += '<circle cx="' + f(rx) + '" cy="' + f(top + PIV * k) + '" r="' + f(Math.max(1.6, 0.45 * k)) + '" fill="#2b2b2e" stroke="#4a4a50" stroke-width=".6"/>';
        });
      }
      if (active) {
        var lx = cx + g.reach * k + 12;
        out += '<g font-family="inherit" font-size="11" font-weight="600" fill="' + blue + '" stroke-linecap="round">';
        out += '<path d="M' + f(lx) + ' ' + f(top) + 'V' + base + 'M' + f(lx - 4) + ' ' + f(top) + 'h8M' + f(lx - 4) + ' ' + base + 'h8" stroke="' + blue + '" stroke-width="1.2" fill="none"/>';
        out += '<text x="' + f(lx + 6) + '" y="' + f((top + base) / 2 + 4) + '">' + fmt(d.h) + ' cm</text>';
        out += '<path d="M' + f(x0) + ' ' + f(top - 12) + 'H' + f(x1) + 'M' + f(x0) + ' ' + f(top - 16) + 'v8M' + f(x1) + ' ' + f(top - 16) + 'v8" stroke="' + blue + '" stroke-width="1.2" fill="none"/>';
        out += '<text x="' + f(cx) + '" y="' + f(top - 17) + '" text-anchor="middle">' + fmt(d.l) + ' cm</text>';
        out += '</g>';
      }
      return out;
    }
    var svg = '<svg viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="Comparación a escala de los tamaños, vista lateral">' +
      '<defs><linearGradient id="kc-steel" x1="0" x2="1"><stop offset="0" stop-color="#8d939b"/><stop offset=".35" stop-color="#e9ecef"/><stop offset=".6" stop-color="#c3c8ce"/><stop offset="1" stop-color="#7f858d"/></linearGradient>' +
      '<radialGradient id="kc-shadow"><stop offset="0" stop-color="#000" stop-opacity=".16"/><stop offset="1" stop-color="#000" stop-opacity="0"/></radialGradient></defs>';
    var dc = data[cur], gc = geo(dc);
    svg += '<ellipse cx="' + f(cx) + '" cy="' + (base + 1) + '" rx="' + f(gc.reach * k * 1.05) + '" ry="5" fill="url(#kc-shadow)"/>';
    svg += '<line x1="4" x2="' + (W - 4) + '" y1="' + base + '" y2="' + base + '" stroke="#d6d9de" stroke-width="1.2"/>';
    data.forEach(function (d, i) { if (i !== cur) svg += shape(d, false); });
    svg += shape(dc, true) + '</svg>';
    holder.innerHTML = svg;
  }
  function fmt(n) { return String(Math.round(n * 10) / 10).replace('.', ','); }

  /* ---------------------------------------------------------------------- */
  /* Sección de compra                                                        */
  /* ---------------------------------------------------------------------- */
  function initBuy(root) {
    loadProduct();
    var pills = $$('[data-kc-variant]', root);
    var priceNow = $('[data-kc-price]', root), priceWas = $('[data-kc-compare]', root);
    var stock = $('[data-kc-stock]', root), sizeTxt = $('[data-kc-size-label]', root);
    var cta = $('[data-kc-own-cta]', root);
    pills.forEach(function (p) {
      p.addEventListener('click', function () { KC.setVariant(p.getAttribute('data-kc-variant'), 'buy'); });
    });
    // Si se eligió mostrar el botón de Releasit pero la app no lo inyecta, se vuelve a nuestro botón
    if (root.getAttribute('data-own-button') === 'false') {
      setTimeout(function () { if (!findRsiButton(root)) root.setAttribute('data-own-button', 'true'); }, 4000);
    }
    KC.onChange(function (v) {
      pills.forEach(function (p) { p.setAttribute('aria-checked', String(p.getAttribute('data-kc-variant')) === String(v.id) ? 'true' : 'false'); });
      if (priceNow) priceNow.textContent = v.price_fmt;
      if (priceWas) { priceWas.textContent = v.compare_fmt || ''; priceWas.hidden = !v.compare_fmt; }
      if (stock) { stock.textContent = v.available ? (root.getAttribute('data-txt-in') || 'Disponible') : (root.getAttribute('data-txt-out') || 'Agotado'); stock.classList.toggle('is-out', !v.available); }
      if (sizeTxt) sizeTxt.textContent = KC.sizeLabel(v);
      if (cta) {
        cta.setAttribute('aria-disabled', v.available ? 'false' : 'true');
        var lbl = $('[data-kc-cta-label]', cta);
        if (lbl) lbl.textContent = v.available ? (cta.getAttribute('data-label') || 'Comprar') : (root.getAttribute('data-txt-out') || 'Agotado');
      }
      syncForms(v);
      updateStickyContent();
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Barra fija                                                               */
  /* ---------------------------------------------------------------------- */
  var sticky, buyVisible = false, footerVisible = false, sizesVisible = false;
  function updateStickyContent() {
    if (!sticky || !KC.variant) return;
    var v = KC.variant;
    var s = $('[data-kc-sticky-size]', sticky), pr = $('[data-kc-sticky-price]', sticky), b = $('.kc-btn', sticky);
    var lbl = KC.sizeLabel(v), sb = $('.kc-sticky__size', sticky);
    if (s) s.textContent = lbl;
    if (sb) { if (lbl) { sb.hidden = false; } else { sb.textContent = (KC.product && KC.product.title) || ''; sb.removeAttribute('data-kc-goto'); } }
    if (pr) pr.textContent = v.price_fmt;
    if (b) b.setAttribute('aria-disabled', v.available ? 'false' : 'true');
  }
  function updateSticky() {
    if (!sticky) return;
    var after = sticky.getAttribute('data-after') || 'story';
    var past = KC.storyProgress === undefined ? (window.scrollY || (doc.querySelector('.page-wrapper') || {}).scrollTop || 0) > 300 : (!!KC.storyStarted || !!KC.storyDone);
    var show = after === 'always' ? past : (!!KC.storyDone && !buyVisible && !footerVisible && !sizesVisible);
    sticky.classList.toggle('is-on', show);
    doc.documentElement.classList.toggle('kc-has-sticky', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    $$('a,button', sticky).forEach(function (el) { el.tabIndex = show ? 0 : -1; });
  }
  function initSticky() {
    var inSection = $$('[data-kc-sticky]').filter(function (el) { return el.parentNode !== doc.body; })[0];
    if (inSection) $$('body > [data-kc-sticky]').forEach(function (el) { el.remove(); });
    sticky = inSection || $('body > [data-kc-sticky]');
    if (!sticky) return;
    // se coloca fuera de cualquier contenedor con transform para que "fixed" funcione
    if (sticky.parentNode !== doc.body) doc.body.appendChild(sticky);
    if ('IntersectionObserver' in window) {
      var watch = function (el, cb) { if (!el) return; new IntersectionObserver(function (en) { cb(en[0].isIntersecting); updateSticky(); }, { threshold: 0.01 }).observe(el); };
      watch($('[data-kc-own-cta]') || $('[data-kc-buy-section]'), function (v) { buyVisible = v; });
      watch($('footer') || $('.footer'), function (v) { footerVisible = v; });
      watch($('[data-kc-sizes] .kc-size-cta'), function (v) { sizesVisible = v; });
    }
    updateStickyContent(); updateSticky();
  }

  /* ---------------------------------------------------------------------- */
  /* Apariciones suaves                                                       */
  /* ---------------------------------------------------------------------- */
  function initReveals() {
    // Tipo de aparición: Configuración del tema > KAIROSDECOR - Comedor
    var style = isPhone() && CFG.revealMobile !== 'same' ? CFG.revealMobile : CFG.revealStyle;
    if (reduceMotion) style = 'none';
    var html = doc.documentElement;
    html.classList.remove('kc-rv-none', 'kc-rv-fade', 'kc-rv-slide');
    html.classList.add('kc-rv-' + (style || 'fade'));
    var els = $$('.kc-reveal, .kc-detail');
    if (style === 'none' || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    // se activa un poco ANTES de entrar en pantalla, para que el contenido ya esté visible al llegar
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px 20% 0px' });
    els.forEach(function (e) { if (e.getBoundingClientRect().top < window.innerHeight * 1.2) e.classList.add('is-in'); else io.observe(e); });
  }

  /* ---------------------------------------------------------------------- */
  /* Arranque                                                                 */
  /* ---------------------------------------------------------------------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { ticking = false; stories.forEach(function (s) { s.update(); }); if (!stories.length) updateSticky(); });
  }

  function boot() {
    loadProduct();
    applyHeader();
    $$('[data-kc-story]').forEach(function (r) { if (!r.__kc) { r.__kc = 1; initStory(r); } });
    $$('[data-kc-sizes]').forEach(function (r) { if (!r.__kc) { r.__kc = 1; initSizes(r); } });
    $$('[data-kc-buy-section]').forEach(function (r) { if (!r.__kc) { r.__kc = 1; initBuy(r); } });
    initSticky();
    initReveals();
    if (KC.variant) KC.setVariant(KC.variant.id, 'force');
  }

  // scroll de la ventana (móvil) y de .page-wrapper (Horizon en escritorio)
  doc.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', function () {
    applyHeader();
    stories.forEach(function (s) { s.bandDirty = true; if (s.scene) s.scene.resize(); s.update(true); if (s.placeSnaps) s.placeSnaps(); if (s.play) s.play(); });
  });

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();

  // Editor de Shopify: re-inicializar al editar secciones
  doc.addEventListener('shopify:section:load', function () {
    stories = stories.filter(function (s) { return doc.body.contains(s.root); });
    KC.product = null; boot();
  });
  doc.addEventListener('shopify:block:select', function (e) {
    var ch = e.target.closest && e.target.closest('[data-kc-chapter]');
    if (!ch) return;
    var st = stories.filter(function (s) { return s.root.contains(ch); })[0];
    if (!st) return;
    var it = st.items.filter(function (i) { return i.el === ch; })[0];
    if (!it) return;
    var track = $('.kc-story__track', st.root);
    var r = track.getBoundingClientRect();
    var range = r.height - ($('.kc-story__stage', st.root).clientHeight || window.innerHeight);
    var scroller = window.innerWidth >= 990 ? ($('.page-wrapper') || doc.scrollingElement) : doc.scrollingElement;
    var y = (scroller === doc.scrollingElement ? window.scrollY : scroller.scrollTop) + r.top + range * ((it.a + it.b) / 2);
    if (scroller === doc.scrollingElement) window.scrollTo(0, y); else scroller.scrollTop = y;
  });
})();
